export default "__VITE_ASSET__3255f348__"